import React from "react";

// Category Card Skeleton
export const CategorySkeleton = () => {
  return (
    <div className="group cursor-pointer">
      <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-orange-100">
        <div className="relative aspect-square overflow-hidden bg-gradient-to-br from-orange-50 to-yellow-50">
          {/* Shimmer effect */}
          <div className="absolute inset-0 shimmer"></div>
        </div>
        <div className="p-3 text-center">
          <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto shimmer"></div>
        </div>
      </div>
    </div>
  );
};

// Banner Skeleton
export const BannerSkeleton = () => {
  return (
    <div className="px-3 py-2">
      <div className="bg-white rounded-3xl overflow-hidden shadow-xl border-2 border-orange-100">
        <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-orange-50 to-yellow-50">
          <div className="absolute inset-0 shimmer"></div>
        </div>
        <div className="p-6 bg-white border-t border-orange-100">
          <div className="h-4 bg-gray-200 rounded w-full mb-2 shimmer"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 shimmer"></div>
        </div>
      </div>
    </div>
  );
};

// Product Card Skeleton
export const ProductSkeleton = () => {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden border border-orange-100">
      <div className="relative aspect-square bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="absolute inset-0 shimmer"></div>
      </div>
      <div className="p-4">
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 shimmer"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2 mb-3 shimmer"></div>
        <div className="h-8 bg-gray-200 rounded shimmer"></div>
      </div>
    </div>
  );
};

// Subcategory Item Skeleton
export const SubcategoryItemSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-orange-100">
      <div className="relative aspect-[4/3] bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="absolute inset-0 shimmer"></div>
      </div>
      <div className="p-4">
        <div className="h-5 bg-gray-200 rounded w-3/4 mb-2 shimmer"></div>
        <div className="h-3 bg-gray-200 rounded w-full mb-2 shimmer"></div>
        <div className="h-3 bg-gray-200 rounded w-2/3 mb-3 shimmer"></div>
        <div className="flex justify-between items-center">
          <div className="h-6 bg-gray-200 rounded w-20 shimmer"></div>
          <div className="h-9 bg-gray-200 rounded w-24 shimmer"></div>
        </div>
      </div>
    </div>
  );
};
